import { render, staticRenderFns } from "./ReceiveAssetTransferModal.vue?vue&type=template&id=c996f7fe&"
import script from "./ReceiveAssetTransferModal.vue?vue&type=script&lang=ts&"
export * from "./ReceiveAssetTransferModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/agent/workspace/SPP/deployment/frontend-erp-spp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c996f7fe')) {
      api.createRecord('c996f7fe', component.options)
    } else {
      api.reload('c996f7fe', component.options)
    }
    module.hot.accept("./ReceiveAssetTransferModal.vue?vue&type=template&id=c996f7fe&", function () {
      api.rerender('c996f7fe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/AssetTransfer/ReceiveAssetTransferModal.vue"
export default component.exports